import { render, staticRenderFns } from "./PlantView.vue?vue&type=template&id=56a78df0&scoped=true&"
import script from "./PlantView.vue?vue&type=script&lang=ts&"
export * from "./PlantView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a78df0",
  null
  
)

export default component.exports